import { WinState } from '@/models/games/blackjack2/enums/WinState';
import { ResultInfo } from '@/models/games/blackjack2/GameInfo';
import { HandInfo } from '@/models/games/blackjack2/HandInfo';
import { GameType } from '@/models/games/enums/GameType';
import { BetRecord } from '@/modules/report/slice/betSummary';
import { Surrender } from '@/modules/rwdGame/blackjack/icon/Surrender';
import {
    IcoBJ,
    IcoBJBust,
    IcoBJLose,
    IcoBJPush,
    IcoBJWin,
} from '@/modules/setting/svg';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BJGameResultCellProps } from '..';
import { BJ2BetRecordPokerList } from '../../pokerList/BetRecordPokerList';
import { BetRecordScroller } from '../../scroller/BetRecordScroller';

enum IconEnum {
    BJ,
    Bush,
    Push,
    Win,
    Lose,
    Surrender,
}
const getSeatsHand = (
    seat: number,
    result: ResultInfo,
    gameid: number
): Array<BJHand> => {
    let hands = [] as Array<BJHand>;

    const seatResult = result.seats_info.find(v => v.seat_num == seat);
    const resultHands = [];
    if (seatResult) {
        resultHands.push(seatResult.h1);
        if (seatResult.is_split) {
            resultHands.push(seatResult.h2);
        }
    }
    // console.log('?????', seatResult, result.seats_info, seat);
    if (resultHands.length > 0) {
        // const isSurrender = seatResult.D == BlackjackDecision.Surrender;
        for (let i = 0; i < resultHands.length; i++) {
            const isBJ = resultHands[i].cp == 'BJ';
            const isB = resultHands[i].cp == 'B';
            const isPush = resultHands[i].r == WinState.Push;
            const isWin = resultHands[i].r == WinState.Win;
            const isSurrender = resultHands[i].r == WinState.Surrender;
            hands.push({
                key: `bj-record-hand-cell-${gameid}-${seat}-${i}`,
                name: resultHands.length > 1 ? `#${i + 1}` : '  ',
                cards: resultHands[i].c,
                point: resultHands[i].cp,
                icon: isSurrender
                    ? IconEnum.Surrender
                    : isPush
                      ? IconEnum.Push
                      : isBJ
                        ? IconEnum.BJ
                        : isB
                          ? IconEnum.Bush
                          : isWin
                            ? IconEnum.Win
                            : IconEnum.Lose,
            });
        }
    }
    return hands;
};
const getBetSeats = (
    betRecords: Array<BetRecord> | undefined
): Array<number> => {
    let seats = [] as Array<number>;
    if (betRecords) {
        for (let i = 0; i < betRecords.length; i++) {
            let tmp = betRecords[i].BetType % 10;
            // console.log('????', tmp, betRecords[i].BetType);
            if (seats.indexOf(tmp) < 0) {
                seats.push(tmp);
            }
        }
    }
    return seats;
};
type BJHand = {
    key: string;
    name: string;
    cards: Array<number>;
    point: string;
    icon: IconEnum;
};
type BJResult = {
    key: string;
    seat: string;
    hands: Array<BJHand>;
};
const seatName = ['', 'S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'S7'];
export const Blackjack2GameResult = (props: BJGameResultCellProps) => {
    const { summary, betRecords, expanded } = props;
    const betSeats = useMemo(
        () => getBetSeats(betRecords).sort(),
        [betRecords]
    );
    const blackjackResult = useMemo(() => {
        let result = undefined;
        try {
            result = JSON.parse(summary.Result) as ResultInfo;
        } catch (e) {
            console.error(e);
        }
        return result;
    }, [summary]);
    const [resultList, setResultList] = useState<Array<BJResult>>([]);
    useEffect(() => {
        if (blackjackResult) {
            let list = [] as Array<BJResult>;
            for (let i = 0; i < betSeats.length; i++) {
                list.push({
                    key: `bj-record-seat-cell-${summary.GameID}-${i}`,
                    seat: seatName[betSeats[i]],
                    hands: getSeatsHand(
                        betSeats[i],
                        blackjackResult,
                        summary.GameID
                    ),
                });
            }
            setResultList(list);
        }
    }, [betSeats, blackjackResult]);
    // TODO
    return (
        <div className="item-blackjack-game-result-container">
            <>
                {blackjackResult && (
                    <MainResult
                        dealerHand={blackjackResult.dealer}
                        betSeats={betSeats}
                    />
                )}
                {expanded &&
                    resultList.map((v, i) => {
                        return (
                            <SeatCell key={v.key} seat={v} isFirst={i == 0} />
                        );
                    })}
            </>
        </div>
    );
};
type MainProp = {
    dealerHand: HandInfo;
    betSeats: Array<number>;
};
const MainResult = (props: MainProp) => {
    const { t } = useTranslation();
    const { dealerHand, betSeats } = props;
    const color = useMemo(() => {
        let color = [0, 0, 0, 0, 0, 0, 0];
        for (let i = 0; i < color.length; i++) {
            if (betSeats.indexOf(i + 1) >= 0) {
                color[i] = 1;
            }
        }
        return color;
    }, [betSeats]);

    return (
        <div className="blackjack-result-frame dealer">
            <div className="item-text-font">{t('tableinfo.dealer')}</div>
            <div className="blackjack-card-frame">
                <BJ2BetRecordPokerList
                    decks={[dealerHand.c]}
                    gameType={GameType.Blackjack}
                />
                <div className="item-text-font white">{dealerHand.cp}</div>
            </div>
            <div className="blackjack-dealer-result-svg">
                <SeatSvg color={color} />
            </div>
        </div>
    );
};

type SeatProp = {
    isFirst: boolean;
    seat: BJResult;
};
const SeatCell = (props: SeatProp) => {
    const { seat } = props;
    return (
        <div className="blackjack-result-frame">
            <div className="item-text-font">{seat.seat}</div>
            {seat.hands.map(v => {
                console.log('????? Hand', v);
                return <HandCell key={v.key} hand={v} />;
            })}
        </div>
    );
};
type HandProp = {
    hand: BJHand;
};
const getIcon = (type: IconEnum) => {
    switch (type) {
        case IconEnum.BJ:
            return <IcoBJ />;
        case IconEnum.Bush:
            return <IcoBJBust />;
        case IconEnum.Lose:
            return <IcoBJLose />;
        case IconEnum.Push:
            return <IcoBJPush />;
        case IconEnum.Win:
            return <IcoBJWin />;
        case IconEnum.Surrender:
            return <Surrender />;
    }
    return <></>;
};
const HandCell = (props: HandProp) => {
    const { hand } = props;
    const iconSvg = useMemo(() => getIcon(hand.icon), [hand.icon]);
    return (
        <div className="item-text-font white blackjack-card-frame seat">
            {hand.name}{' '}
            <div className="seat-cardlist-container">
                <BetRecordScroller gameType={GameType.Blackjack}>
                    <BJ2BetRecordPokerList decks={[hand.cards]} />
                </BetRecordScroller>
            </div>
            {hand.point}
            <div className="blackjack-result-icon">{iconSvg}</div>
        </div>
    );
};

type SeatSvgProp = {
    color: Array<number>;
};
const SeatSvg = ({ color }: SeatSvgProp) => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 404 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="100"
                y="1.297"
                width="21"
                height="21"
                rx="10.5"
                fill="#333"
            />
            <rect
                x="130.5"
                y="10.297"
                width="21"
                height="21"
                rx="10.5"
                fill="#333"
            />
            <rect
                x="161"
                y="14.797"
                width="21"
                height="21"
                rx="10.5"
                fill="#333"
            />
            <rect
                x="191.5"
                y="14.797"
                width="21"
                height="21"
                rx="10.5"
                fill="#333"
            />
            <path
                d="M232.5 14.797c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5-10.5-4.7-10.5-10.5 4.701-10.5 10.5-10.5"
                fill="#333"
            />
            <rect
                x="252.5"
                y="10.297"
                width="21"
                height="21"
                rx="10.5"
                fill="#333"
            />
            <path
                d="M293.5 1.297c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5-10.5-4.7-10.5-10.5 4.701-10.5 10.5-10.5"
                fill="#333"
            />
            <path
                d="m108.398 16.547 3.216-7.044h-4.224V7.98h6.144v1.14l-3.24 7.428z"
                fill={color[6] ? '#fff' : '#999'}
            />
            <path
                d="M137.986 21.911q0-.732.108-1.452.108-.732.372-1.368.276-.648.756-1.14.492-.504 1.236-.78.756-.288 1.824-.288.252 0 .588.024.336.012.564.06v1.452a7 7 0 0 0-.504-.084 4 4 0 0 0-.528-.036q-1.068 0-1.656.336-.576.336-.816.948-.24.6-.276 1.392h.072q.24-.42.684-.708.456-.288 1.176-.288 1.128 0 1.788.708t.66 2.004q0 1.392-.792 2.184-.78.792-2.124.792a3.2 3.2 0 0 1-1.584-.396q-.708-.408-1.128-1.236-.42-.84-.42-2.124m3.096 2.304q.528 0 .864-.36.336-.372.336-1.14 0-.624-.288-.984t-.876-.36q-.408 0-.708.18a1.4 1.4 0 0 0-.456.456q-.168.264-.168.552 0 .396.144.78t.432.636q.3.24.72.24"
                fill={color[5] ? '#fff' : '#999'}
            />
            <path
                d="M171.666 24.575q.78 0 1.392.3t.96.876q.36.576.36 1.428 0 1.392-.864 2.196-.864.792-2.556.792-.672 0-1.272-.12a4 4 0 0 1-1.032-.348v-1.56a5.5 5.5 0 0 0 1.068.396q.624.156 1.176.156.804 0 1.224-.324.432-.336.432-1.032 0-1.296-1.716-1.296-.336 0-.696.072-.36.06-.6.12l-.72-.384.324-4.368h4.644v1.536h-3.06l-.156 1.68q.204-.036.432-.072.24-.048.66-.048"
                fill={color[4] ? '#fff' : '#999'}
            />
            <path
                d="M205.226 28.271h-1.032v1.776h-1.764v-1.776h-3.66v-1.26l3.756-5.532h1.668v5.388h1.032zm-2.796-1.404v-1.452q0-.276.012-.672l.024-.732q.024-.348.036-.456h-.048q-.108.24-.24.468-.12.228-.276.468l-1.572 2.376z"
                fill={color[3] ? '#fff' : '#999'}
            />
            <path
                d="M235.198 23.4q0 .887-.54 1.415a2.73 2.73 0 0 1-1.308.72v.036q1.02.132 1.56.636t.54 1.344q0 .744-.372 1.344-.36.588-1.128.936-.756.336-1.956.336-1.392 0-2.472-.468v-1.536a5.4 5.4 0 0 0 2.28.564q.972 0 1.356-.336.396-.336.396-.948 0-.348-.18-.6t-.636-.372q-.444-.132-1.248-.132h-.648v-1.392h.66q.792 0 1.2-.144.42-.156.564-.408.156-.264.156-.6 0-.456-.288-.708-.276-.264-.936-.264a2.5 2.5 0 0 0-1.068.216 7 7 0 0 0-.756.408l-.84-1.248q.504-.36 1.176-.6.684-.24 1.62-.24 1.32 0 2.088.54.78.528.78 1.5"
                fill={color[2] ? '#fff' : '#999'}
            />
            <path
                d="M266.034 25.547h-5.988v-1.26l2.148-2.172q.648-.672 1.044-1.116.396-.456.576-.816.18-.372.18-.792 0-.516-.288-.768-.276-.252-.756-.252-.492 0-.96.228t-.984.648l-.984-1.164q.36-.312.78-.588.42-.288.96-.456.552-.18 1.32-.18.84 0 1.44.312.612.3.936.828.336.516.336 1.176 0 .708-.288 1.296-.276.588-.816 1.164-.528.576-1.284 1.272l-1.104 1.032v.084h3.732z"
                fill={color[1] ? '#fff' : '#999'}
            />
            <path
                d="M295.022 16.547h-1.812v-4.956a36 36 0 0 1 .048-1.704 4 4 0 0 1-.264.264q-.192.18-.36.324l-.984.792-.876-1.092 2.76-2.196h1.488z"
                fill={color[0] ? '#fff' : '#999'}
            />
            {color[6] && (
                <rect
                    x="100"
                    y="1.297"
                    width="21"
                    height="21"
                    rx="10.5"
                    stroke="#BF9A5D"
                    strokeWidth="1.5"
                />
            )}
            {color[5] && (
                <rect
                    x="130.5"
                    y="10.297"
                    width="21"
                    height="21"
                    rx="10.5"
                    stroke="#BF9A5D"
                    strokeWidth="1.5"
                />
            )}
            {color[4] && (
                <rect
                    x="161"
                    y="14.797"
                    width="21"
                    height="21"
                    rx="10.5"
                    stroke="#BF9A5D"
                    strokeWidth="1.5"
                />
            )}
            {color[3] && (
                <rect
                    x="191.5"
                    y="14.797"
                    width="21"
                    height="21"
                    rx="10.5"
                    stroke="#BF9A5D"
                    strokeWidth="1.5"
                />
            )}
            {color[2] && (
                <path
                    d="M232.5 14.797c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5-10.5-4.7-10.5-10.5 4.701-10.5 10.5-10.5Z"
                    stroke="#BF9A5D"
                    strokeWidth="1.5"
                />
            )}
            {color[1] && (
                <rect
                    x="252.5"
                    y="10.297"
                    width="21"
                    height="21"
                    rx="10.5"
                    stroke="#BF9A5D"
                    strokeWidth="1.5"
                />
            )}
            {color[0] && (
                <path
                    d="M293.5 1.297c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5-10.5-4.7-10.5-10.5 4.701-10.5 10.5-10.5Z"
                    stroke="#BF9A5D"
                    strokeWidth="1.5"
                />
            )}
        </svg>
    );
};
